import Product from '@grafikr/shopify-typescript/type/Product';
import { component } from 'picoapp';
import { clear } from 'utils/node';

export default component(async (node) => {
  const isShared = node.hasAttribute('data-shared');
  const output = node.querySelector<HTMLElement>('[data-output]');
  const empty = node.querySelector<HTMLElement>('[data-empty]');

  const getProducts = async () => {
    if (isShared) {
      const items = await window.WishlistKing.toolkit.sharedWishlists.get();
      return items[0];
    }

    return window.WishlistKing.toolkit.collection.items[0];
  };

  const renderProducts = async () => {
    const items = await getProducts();

    if (items.products.length > 0) {
      const handles: Pick<Product, 'handle'>[] = items.products.map((product: Product) => product.handle);

      const productPromises = handles.map(async (handle) => {
        const item = await fetch(`/products/${handle}?view=item`);
        let text = await item.text();

        if (isShared) {
          // Remove <!-- wishlist comment -->
          text = text.replace(/<!--[\s\S]*?-->/g, '');
        }

        return text;
      });

      const products = await Promise.all(productPromises);
      clear(output);

      products.forEach((product) => {
        output.insertAdjacentHTML('beforeend', product);
      });

      document.dispatchEvent(new CustomEvent('app:mount'));
    } else {
      clear(output);
      empty.hidden = false;
    }
  };

  document.addEventListener('wishlist:ready', renderProducts);
});
